import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getData, getDataById, getUsBank, getInBank, updateData, getcountries } from '../../../services/admin/invoiceReceipt/invoiceReceiptServices';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';

const InvoiceReceiptReceived = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id  : '',
    bank_address  : '',
    bank_name  : '',
    beneficiarys_account_number  : '',
    beneficiarys_address  : '',
    beneficiarys_name  : '',
    billing_address  : '',
    billing_country  : '',
    billing_email  : '',
    billing_name  : '',
    billing_phone_no  : '',
    createdAt  : '',
    currency  : '',
    event_date  : '',
    event_title  : '',
    event_type  : '',
    in_branch_code  : '',
    in_iban_bic_code  : '',
    in_swift_code  : '',
    invoice_date  : '',
    invoice_id  : '',
    no_of_ticket  : '',
    payment_mode  : '',
    pdf_status  : '',
    reg_amount  : '',
    registration_type  : '',
    series  : '',
    sub_domain  : '',
    subject  : '',
    updatedAt  : '',
    us_ein_number  : '',
    us_iban_number  : '',
    us_swift_bic_code  : '',
    vat_number  : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [usBank, setUsBank] = useState([]);
  const [inBank, setInBank] = useState([]);
  const [selectedBankName, setSelectedBankName] = useState('');
  const [bankError, setBankError] = useState('');
  const [dropdownData, setDropdownData] = useState({
        countries: [],
  });

  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ pdf_status: 0});
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  
   // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries(),        
      ]);
  
      setDropdownData({
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  useEffect(() => {
  const fetchDataAsync = async () => {
    setLoading(true); 
    await fetchData();
    await fetchDropdownData();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLoading(false); 
  };

  fetchDataAsync();

  // Fetch only active (status === 1) US and IN banks
    getUsBank()
      .then((banks) => {
        const activeBanks = banks.filter(bank => bank.status === true);
        setUsBank(activeBanks);
      })
      .catch(console.error);

    getInBank()
      .then((banks) => {
        const activeBanks = banks.filter(bank => bank.status === true);
        setInBank(activeBanks);
      })
      .catch(console.error);
    }, [fetchData, fetchDropdownData]);


  const handleBankSelect = (e) => {
    const selected = e.target.value;
    setSelectedBankName(selected);
    setBankError(''); // Clear previous error if any


    let selectedBank;
    if (selected === 'us') {
      selectedBank = usBank[0]; // Adjust if you need dynamic selection
    } else if (selected === 'in') {
      selectedBank = inBank[0];
    }

    if (selectedBank) {
      setForm((prev) => ({
        ...prev,
        bank_name: selectedBank.bank_name || '',
        bank_address: selectedBank.bank_address || '',
        beneficiarys_name: selectedBank.beneficiarys_name || '',
        beneficiarys_account_number: selectedBank.beneficiarys_account_number || '',
        beneficiarys_address: selectedBank.beneficiarys_address || '',
        in_branch_code: selectedBank.in_branch_code || '',
        in_iban_bic_code: selectedBank.in_iban_bic_code || '',
        in_swift_code: selectedBank.in_swift_code || '',
        us_ein_number: selectedBank.us_ein_number || '',
        us_iban_number: selectedBank.us_iban_number || '',
        us_swift_bic_code: selectedBank.us_swift_bic_code || '',
        vat_number: selectedBank.vat_number || ''
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Inside your invoiceReceiptGenerated component
  const navigate = useNavigate();  // Initialize the useHistory hook
  
  const pdfModal = async (type, row) => {
    if (!selectedBankName) {
      setBankError('Please select a bank.');
      return;
    }
    try {
      // Send the ID in the body of a POST request
      await updateData(form);
      const data = await getDataById({ id: form.id });

      // If the data is fetched successfully, navigate to the PDF page
      if (data) {
        // Assuming you want to pass the data to another page
        navigate('/invoiceReceiptPdf', { state: { data } });  // Use navigate to go to PDF page with state
      }
    } catch (error) {
      console.error('Error fetching data by ID:', error);
    }
  };

  const openModal = (type, data = { 
    id  : '',
    bank_address  : '',
    bank_name  : '',
    beneficiarys_account_number  : '',
    beneficiarys_address  : '',
    beneficiarys_name  : '',
    billing_address  : '',
    billing_country  : '',
    billing_email  : '',
    billing_name  : '',
    billing_phone_no  : '',
    createdAt  : '',
    currency  : '',
    event_date  : '',
    event_title  : '',
    event_type  : '',
    in_branch_code  : '',
    in_iban_bic_code  : '',
    in_swift_code  : '',
    invoice_date  : '',
    invoice_id  : '',
    no_of_ticket  : '',
    payment_mode  : '',
    pdf_status  : '',
    reg_amount  : '',
    registration_type  : '',
    series  : '',
    sub_domain  : '',
    subject  : '',
    updatedAt  : '',
    us_ein_number  : '',
    us_iban_number  : '',
    us_swift_bic_code  : '',
    vat_number  : ''
  }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  };

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  const filteredData = useMemo(() => {
      return dataList.filter(
        (data) => data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
        data.billing_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.reg_amount.toString().includes(searchText.toLowerCase())
      )
      .sort((a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Invoice Date',
      selector: (row) => row.invoice_date,
      sortable: true,
      width: '10%',
      wrap:true
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    width: '10%',
    wrap:true
   },
    {
      name: 'Sub domain',
      selector: (row) => row.sub_domain,
      sortable: true,
      width: '10%',
      wrap: true
    },
    {
      name: 'Name',
      selector: (row) => row.billing_name,
      sortable: true,
      width: '10%',
      wrap: true
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_country),
      sortable: true,
      width: '10%',
      wrap: true

    },
    {
      name: 'Reg Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.reg_amount}</b>;
      },
      sortable: true,
      width: '10%',
      wrap: true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="danger" size="sm" onClick={() => openModal('edit', row)} > <i className="align-middle far fa-fw fa-file-pdf"></i>PDF</Button>
        </div>
      ),
      width: '15%',
      wrap: true
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='fs-4 text-dark'>PDF Generation / Invoice Receipt / Invoice Received Receipt </p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Invoice Id</Form.Label> <small className='text-danger'>*</small>
                  <Form.Control type="text" name="invoice_id" value={form.invoice_id} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3">
                <Form.Label>Select Bank <small className="text-danger">*</small></Form.Label>
                <Form.Select value={selectedBankName} onChange={handleBankSelect} isInvalid={!!bankError}>
                  <option value="">-- Select Bank --</option>
                  {inBank.length > 0 && <option value="in">India Bank</option>}
                  {usBank.length > 0 && <option value="us">US Bank</option>}
                </Form.Select>
                {bankError && <Form.Text className="text-danger">{bankError}</Form.Text>}
              </Form.Group>

              </Form>
              <Table striped bordered hover responsive className="table-sm">
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Invoice Details </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Invoice Id</td>
                    <td>{form.invoice_id}</td>
                  </tr>
                  <tr>
                    <td>Invoice Date</td>
                    <td>{form.invoice_date}</td>
                  </tr>
                  <tr>
                    <td>Registration Type</td>
                    <td>{form.registration_type}</td>
                  </tr>
                  <tr>
                    <td>Registration Amount</td>
                    <td>{form.reg_amount}</td>
                  </tr>
                  <tr>
                    <td>Number of Ticket</td>
                    <td>{form.no_of_ticket}</td>
                  </tr>
                  <tr>
                    <td>Currency</td>
                    <td>{form.currency}</td>
                  </tr>
                  <tr>
                    <td>Payment Mode</td>
                    <td>{form.payment_mode}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Billing Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{form.billing_name}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{form.billing_email}</td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>{form.billing_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{form.billing_address}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{getCountryName(form.billing_country)}</td>
                  </tr>
                </tbody>
                <br></br>
                <thead>
                  <tr>
                    <th className='bg-secondary text-white' colSpan={2}>Bank Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Beneficiarys Name</td>
                    <td>{form.beneficiarys_name}</td>
                  </tr>
                  <tr>
                    <td>Beneficiarys Address</td>
                    <td>{form.beneficiarys_address}</td>
                  </tr>
                  <tr>
                    <td>Bank Name</td>
                    <td>{form.bank_name}</td>
                  </tr>
                  <tr>
                    <td>Bank Address</td>
                    <td>{form.bank_address}</td>
                  </tr>
                  <tr>
                    <td>Beneficiarys Acc No</td>
                    <td>{form.beneficiarys_account_number}</td>
                  </tr>
                  {form.in_swift_code && (
                    <tr>
                      <td>SWIFT Code</td>
                      <td>{form.in_swift_code}</td>
                    </tr>
                  )}

                  {form.in_branch_code && (
                    <tr>
                      <td>Branch Code</td>
                      <td>{form.in_branch_code}</td>
                    </tr>
                  )}

                  {form.in_iban_bic_code && (
                  <tr>
                  <td>IBAN and BIC</td>
                  <td>{form.in_iban_bic_code}</td>
                  </tr>
                  )}

                  {form.us_swift_bic_code && (
                  <tr>
                  <td>SWIFT / BIC Code</td>
                  <td>{form.us_swift_bic_code}</td>
                  </tr>
                  )}

                  {form.us_iban_number && (
                  <tr>
                  <td>IBAN Number</td>
                  <td>{form.us_iban_number}</td>
                  </tr>
                  )}

                  {form.us_ein_number && (
                  <tr>
                  <td>EIN</td>
                  <td>{form.us_ein_number}</td>
                  </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={() => pdfModal('edit', form)}> Generate PDF </Button>
            </Modal.Footer>
          </Modal>

        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default InvoiceReceiptReceived;